module.exports = __webpack_public_path__ + "img/icon-contributors.d427ce50.svg";